import { Combobox, ComboboxOption } from '@schuettflix/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTACT_PERSON_ROLES_LABEL, Role, RoleType } from '@/modules/location/components/roleselector/Roles.ts';

export type RoleSelectorProps = {
    value: Role | null;
    errorMessage?: string;
    onChange: (value: Role | null) => void;
};

export const RoleSelector = (props: RoleSelectorProps) => {
    const { t } = useTranslation();
    const options: ComboboxOption<RoleType>[] = Object.entries(CONTACT_PERSON_ROLES_LABEL).map(([key, value]) => ({
        value: key as RoleType,
        label: t(value),
    }));

    return (
        <Combobox<RoleType>
            variant="sm"
            options={options}
            value={props.value?.value ?? null}
            placeholder={t('contactPerson.panel.roleSelector.label')}
            errorMessage={props.errorMessage}
            optionsClassName="z-20"
            name="default-combobox"
            noOptionFoundLabel="No Results found"
            onChange={role => {
                if (role === null) {
                    props.onChange(null);
                } else {
                    props.onChange({ value: role });
                }
            }}
        />
    );
};
